import React from "react";
import EntriesSelector from "./EntriesSelector";
import SearchInput from "./SearchInput";
import { FileExportBtn } from "./FileExportBtn";

const TableHeader = ({ tabledata }) => {
  const {
    Entries,
    limit,
    onLimitChange,
    options,
    search = false,
    SearchInputValue,
    handleSearch,
    copy,
    csv,
    pdf,
    print,
    modifiedColumns,
    rows,
    prepareRow,
    BtnPosition,
    fileName,
  } = tabledata;
  return (
    <>
      <div className="row g-3 align-items-center justify-content-between table-header mb-3">
        {/* Entries Selector */}
        {Entries && (
          <div className="col-md-6 user-select-none col-12">
            <EntriesSelector
              limit={limit}
              onLimitChange={onLimitChange}
              options={options}
            />
          </div>
        )}

        {/* Export Buttons */}
        {(copy || csv || pdf || print) && (
          <div className="col-md-6 col-12 text-lg-end ms-auto">
            <FileExportBtn
              copy={copy}
              csv={csv}
              pdf={pdf}
              print={print}
              modifiedColumns={modifiedColumns}
              rows={rows}
              prepareRow={prepareRow}
              BtnPosition={BtnPosition}
              fileName={fileName}
            />
          </div>
        )}

        {search && (
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 ms-auto">
            <SearchInput value={SearchInputValue} onChange={handleSearch} />
          </div>
        )}

      </div>


    </>
  );
};

export default TableHeader;
